module.exports = __webpack_public_path__ + "media/img/google-play-white-e77213e5.png";